import React from 'react';
import { getLevelFromXP, getLevelTitle } from '../../utils/gamificationManager';

const LevelBadge = ({ totalXP, size = 'medium', showTitle = true, onClick }) => {
  const level = getLevelFromXP(totalXP);
  const { title, color, icon } = getLevelTitle(level);

  const sizeClasses = {
    small: 'level-badge-small',
    medium: 'level-badge-medium',
    large: 'level-badge-large'
  };

  return (
    <div 
      className={`level-badge ${sizeClasses[size]} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      style={{ borderColor: color }}
    >
      <div className="level-badge-icon" style={{ background: color }}>
        <span className="level-icon-emoji">{icon}</span>
        <span className="level-number">{level}</span>
      </div>
      
      {showTitle && (
        <div className="level-badge-info">
          <div className="level-title" style={{ color: color }}>
            Level {level}
          </div>
          <div className="level-rank">{title}</div>
        </div>
      )}
    </div>
  );
};

export default LevelBadge;
